import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {useGetOneNomenclaturesAreaType} from '@/modules/settings/hooks/useNomenclaturesAreaType';
const UserRegistersAccessTypeCell = ({entity}) => {
  const {data} = useGetOneNomenclaturesAreaType({id: entity?.areaAccess});
  return (
    // <Link to={`${ROUTE_PATH_NOMENCLATURES_SERVICES_CATEGORY}/${entity._id}`}>
    <div className={'flex flex-row'}>
      <div className={'flex flex-col justify-center'}>
        <span className={
          'font-medium lg:font-normal ' +
            'mb-1 lg:mb-0'
            // 'text-lg lg:text-base text-black lg:text-primary'
        }>
          {data?.data?.name}
        </span>
      </div>
    </div>
    // </Link>
  );
};

UserRegistersAccessTypeCell.propTypes = {
  entity: PropTypes.object,
};
UserRegistersAccessTypeCell.defaultProps = {
  entity: {},
};

export default memo(UserRegistersAccessTypeCell);


/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderUserRegistersAccessTypeCell = (text, entity) => {
  return (
    <UserRegistersAccessTypeCell entity={entity}/>
  );
};

